// src/features/encounter/encounterSlice.ts
//       // ❷ 환자 정보 수정 API 호출
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { SugaSerializer } from "@/types/suga"
import { fetchSugas } from "@core/api/sugaApi"

interface SugaPayload {
  sugas: SugaSerializer[] | null
  loading: boolean
  error: string | null
}

const initialState: SugaPayload = {
  sugas: null,
  loading: false,
  error: null,
}

const sugaSlice = createSlice({
  name: "suga",
  initialState,
  reducers: {
    clearSugas(state) {
      state.sugas = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchSugas.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSugas.fulfilled, (state, action) => {
        state.loading = false
        state.sugas = action.payload
        // console.debug("수가 목록", state.sugas)
      })
      .addCase(fetchSugas.rejected, (state, action) => {
        state.loading = false
        state.sugas = null
        state.error =
          (action.payload as string) || action.error.message || "오류 "
      })
  },
})

export const { clearSugas, setLoading, setError } = sugaSlice.actions

export default sugaSlice.reducer
